import { format, parse, isValid, parseISO, startOfMonth, lastDayOfMonth, differenceInCalendarDays, addMonths } from 'date-fns'
import pt from 'date-fns/locale/pt-BR'
import Msg from '../components/core/mensagem'
import Conf from '../components/core/confirmacao'
import $theme from 'theme'

const ui = {
  Confirmacao: function (tipo, mensagem, callbackSim, callbackNao, titulo, sim, nao) {
    const componentInstance = new this.instance({
      ...Conf,
      propsData: {
        tipo: tipo,
        titulo: titulo,
        mensagem: mensagem,
        sim: sim,
        nao: nao,
        callbackSim: callbackSim,
        callbackNao: callbackNao
      },
      vuetify: this.instance.vuetify
    })

    componentInstance.$mount()
  },
  Mensagem: function (tipo, mensagem, callback, titulo, ok) {
    const componentInstance = new this.instance({
      ...Msg,
      propsData: {
        tipo: tipo,
        titulo: titulo,
        mensagem: mensagem,
        ok: ok,
        callback: callback
      },
      vuetify: this.instance.vuetify
    })
    componentInstance.$mount()
  },
  ShowError: function (title, message) {
    if (!$theme.options.disableErrorMessages) { notify(this.instance, title || 'Erro', message, 'error') }
  },
  ShowAlert: function (title, message) {
    if (!$theme.options.disableAlertMessages) { notify(this.instance, title || 'Atenção', message, 'warn') }
  },
  ShowSuccess: function (title, message) {
    if (!$theme.options.disableSuccessMessages) { notify(this.instance, title || 'Sucesso', message, 'success') }
  },
  showErrorIcon (el) {
    if ($theme.options.iconError && el) {
      return el.getAttribute('data-invalid') === 'true'
    }
    return false
  },
  FormValidate: function (th) {
    var form = null
    if (th && th.$refs && th.$refs.form) { form = th.$refs.form }
    if (form && form.validate()) {
      return true
    } else {
      var msg = []
      const invalidFields = form.$el.querySelectorAll('[data-invalid=true]')
      invalidFields.forEach(function (p, i) {
        if (i === 0) {
          const el = p.getElementsByTagName('input')
          if (el && el[0]) {
            el[0].focus()
            th.$vuetify.goTo(el[0], { container: form })
          }
        }
        msg.push(p.getAttribute('data-message'))
      })
      if (!$theme.options.disableFormValidation) { ui.ShowError('Formulário Inválido', msg.join('<br/>')) }
      return false
    }
  },
  PostAction: function (response, mensagem) {
    if (response && response.sucesso) { response.success = response.sucesso }
    if (response.error) {
      try {
        const obj = JSON.parse(response.error)
        if (obj.HasError && obj.Messages) {
          ui.ShowError('Erro', obj.Messages.map(p => p.Description).join('<br/>'))
        } else {
          ui.ShowError('Erro', response.error)
        }
      } catch {
        ui.ShowError('Erro', response.error)
      }
      return false
    } else if (!response.success && response.mensagem) {
      try {
        var obj = JSON.parse(response.mensagem);

        if (obj.HasError && obj.Messages) {
          ui.ShowError('Erro', obj.Messages.map(function (p) {
            return p.Description;
          }).join('<br/>'));
        }
      } catch {
        ui.ShowError('Erro', response.mensagem);
      }

      return false;
    } else if (response.errors && response.errors.length > 0) {
      ui.ShowError('Erro', response.errors[0])
      return false
    } else if (response.errors && !response.errors.length) {
      ui.ShowError('Erro', JSON.stringify(response.errors))
      return false
    } else if (!response.success && response.mensagem) {
      ui.ShowError('Erro', JSON.stringify(response.mensagem))
      return false
    } else if (response.isAxiosError && response.message) {
      ui.ShowError('Erro', JSON.stringify(response.message))
      return false
    } else if (!response.Result && response.Msg) {
      ui.ShowError('Erro', response.Msg.replace(/[\r\n]/g, '<br/>'))
      return false
    } else {
      ui.ShowSuccess('Sucesso', mensagem || 'Operação realizada com sucesso!')
      return true
    }
  },
  PostLoadData: function (response, showError) {
    if (response && response.sucesso) { response.success = response.sucesso }
    let r = { success: true, message: null }
    if (response.error) {
      try {
        const obj = JSON.parse(response.error)
        if (obj.HasError && obj.Messages) {
          r = { success: false, message: obj.Messages.map(p => p.Description).join('<br/>') }
        } else {
          r = { success: false, message: response.error.replace(/[\n\r]/g, '<br/>') }
        }
      } catch {
        r = { success: false, message: response.error.replace(/[\n\r]/g, '<br/>') }
      }
    } else if (!response.success && response.mensagem) {
      try {
        var obj = JSON.parse(response.mensagem);

        if (obj.HasError && obj.Messages) {
          r = { success: false, message: obj.Messages.map(p => p.Description).join('<br/>') }
        }
      } catch (_unused) {
        r = { success: false, message: response.mensagem.replace(/[\n\r]/g, '<br/>') }
      }
    } else if (response.errors && response.errors.length > 0) {
      r = { success: false, message: response.errors[0].replace(/[\n\r]/g, '<br/>') }
    } else if (response.errors && !response.errors.length) {
      r = { success: false, message: JSON.stringify(response.errors).replace(/[\n\r]/g, '<br/>') }
    } else if (!response.success && response.mensagem) {
      r = { success: false, message: JSON.stringify(response.mensagem).replace(/[\n\r]/g, '<br/>') }
    } else if (response.isAxiosError && response.message) {
      r = { success: false, message: JSON.stringify(response.message).replace(/[\n\r]/g, '<br/>') }
    } else if (!response.Result && response.Msg) {
      r = { success: false, message: response.Msg.replace(/[\n\r]/g, '<br/>') }
    }

    if (showError && !r.success) { ui.ShowError('Erro', r.message) }

    return r.success
  },
  ShowLoading: function () {
    this.store.commit('loading', true)
  },
  HideLoading: function () {
    this.store.commit('loading', false)
  },
  Redirect: function (that, path, data) {
    const dto = {
      path: path
    }

    if (data) { dto.query = { data: JSON.stringify(data) } }

    that.$router.push(dto)
  },
  GetRequest: function (that) {
    if (that.$route.query && that.$route.query.data) { return JSON.parse(that.$route.query.data) } else { return null }
  },
  Timeout: {
    Default (retest, timeout) {
      timeout = timeout || 0
      setTimeout(() => {
        timeout = retest()
        if (timeout) { ui.Timeout.Default(retest, timeout) }
      }, timeout)
    },
    GridRefresh (context) {
      ui.Timeout.Default(() => {
        if (context.$refs && context.$refs.grid) {
          context.$refs.grid.refresh()
        } else { return 10 }
      })
    }
  },
  Format: {
    MascaraDigito: function (tamanho) {
      const mask = []
      let sMask = '#'
      for (var i = 0; i < tamanho - 2; i++) {
        mask.push(sMask + '-#')
        sMask += '#'
      }
      return mask
    },
    MascaraNumero: function (tamanho) {
      const mask = []
      let sMask = '#'
      for (var i = 0; i < tamanho - 2; i++) {
        mask.push(sMask)
        sMask += '#'
      }
      return mask
    },
    Date: function (value, dateFormat) {
      if (!dateFormat) { dateFormat = 'dd/MM/yyyy' }
      if (value) {
        if (!(value instanceof Date)) { value = parseISO(value) }
        const date = format(value, dateFormat, { locale: pt })
        return date
      }
      return ''
    },
    DateTime: function (value, dateFormat) {
      if (!dateFormat) { dateFormat = 'dd/MM/yyyy HH:mm:ss' }
      if (value) {
        if (!(value instanceof Date)) { value = parseISO(value) }
        const date = format(value, dateFormat, { locale: pt })
        return date
      }
      return ''
    },
    Time: function (value, mask) {
      if (!mask) { mask = '00:00' }

      if (!value) { return '' }

      mask = mask.replace(/:/g, '')
      value = value.replace(/:/g, '')
      const ml = mask.length

      if (ml > value.length) { value = mask.substr(0, (mask.length - value.length)) + value }

      if (ml < value.length) { value = value.substr(0, ml) }

      value = value.replace(/(\d{2})/g, '$1:')
      value = value.substr(0, value.length - 1)
      return value
    },
    Currency: function (value) {
      if (value) {
        const val = value.toString().replace(',', '.')
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val)
      }
      return 'R$ 0,00'
    },
    Decimal: function (value, digits) {
      if (!digits && digits !== 0) { digits = 2 }
      if (value) {
        const val = (value / 1).toFixed(digits).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d)(,[0-9]*))/g, '.')
      }
      return '0,00'
    },
    Percentual: function (value, digits) {
     return ui.Format.Decimal(value, digits) + '%'
    },
    DocumentoFederal: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        if (value.length === 11) {
          const regex = /([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/
          const subst = '$1.$2.$3-$4'
          return value.replace(regex, subst)
        } else if (value.length === 14) {
          const regex = /([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})/
          const subst = '$1.$2.$3/$4-$5'
          return value.replace(regex, subst)
        }
        return value
      }
      return ''
    },
    Celular: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        const regex = /([0-9]{2})([0-9]{4})([0-9]{1})?([0-9]{4})/
        const subst = '\($1\) $2$3-$4'    // eslint-disable-line

        return value.replace(regex, subst)
      }
      return ''
    },
    Telefone: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        const regex = /([0-9]{2})([0-9]{4})([0-9]{1})?([0-9]{4})/
        const subst = '\($1\) $2$3-$4'   // eslint-disable-line

        return value.replace(regex, subst)
      }
      return ''
    },
    SomenteNumeros: function (value) {
      if (value) { return value.replace(/[^0-9]/g, '') }
      return ''
    },
    LinhaDigitavel: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        const regex = /([0-9]{5})([0-9]{5})([0-9]{5})([0-9]{6})([0-9]{5})([0-9]{6})([0-9]{1})([0-9]{14})/
        const subst = '$1.$2.$3.$4.$5.$6.$7.$8'

        return value.replace(regex, subst)
      }
      return ''
      // "'#####.#####.#####.######.#####.######.#.##############'"
    },
    LeftPadNumbers: function (value, totalWidth, paddingChar) {
      if (!value) { value = '' }
      var length = totalWidth - value.toString().length + 1
      if (length < 0) { length = 0 }
      return Array(length).join(paddingChar || '0') + value
    },
    Cep: function (value) {
      if (value) {
        value = value.toString().replace(/[^0-9]/g, '')
        if (value.length === 8) {
          const regex = /([0-9]{2})([0-9]{3})([0-9]{3})/
          const subst = '$1.$2-$3'
          return value.replace(regex, subst)
        }
        return value
      }
      return ''
    }
  },
  Parse: {
    Decimal: function (value, precision) {
      if (!value) { return 0 }
      if (!precision) { precision = 2 }
      if (typeof value === 'number') { return value }
      let div = Math.pow(10, precision)
      // eslint-disable-next-line
      const rg = /[\.\,]/g
      const index = value.regexIndexOf(rg)
      const lastIndex = value.regexLastIndexOf(rg)

      if (index < 0) { return parseFloat(value) } else {
        if (lastIndex === (value.length - 1)) {
          value += '00'
        } else if (lastIndex === (value.length - 2)) {
          value += '0'
        } else if (lastIndex < (value.length - 3)) {
          div = precision ? div : 1
        }
      }
      // eslint-disable-next-line
      return parseInt(value.toString().replace(/[\.\,]/g, '')) / div
    },
    Date: function (value, dateFormat) {
      let date = value
      if (!dateFormat) { dateFormat = 'dd/MM/yyyy' }

      if (value) {
        if (typeof value === 'string') {
          date = parse(value, dateFormat, new Date(), { locale: pt })
          if (!isValid(date)) { date = parseISO(value) }
        }
        return date
      }
    }
  },
  Date: {
    DataAtual: function (dateFormat) {
      return ui.Format.Date(new Date(), dateFormat)
    },
    PrimeiroDiaMes: function (date) {
      if (!(date instanceof Date)) {
        date = parseISO(date)
      }
      return startOfMonth(date)
    },
    UltimoDiaMes: function (date) {
      if (!(date instanceof Date)) {
        date = parseISO(date)
      }
      return lastDayOfMonth(date)
    },
    AddDay: function (date, dias) {
      if (!(date instanceof Date)) {
        date = parseISO(date)
      }
      if (!dias) { dias = 0 }
      dias = date.getDate() + dias
      date.setDate(dias)
      return date
    },
    AddMonth: function (date, meses) {
      if (!(date instanceof Date)) {
        date = parseISO(date)
      }
      if (!meses) { meses = 0 }
      return addMonths(date, meses)
    },
    AddYear: function (date, anos) {
      if (!(date instanceof Date)) {
        date = parseISO(date)
      }
      if (!anos) { anos = 0 }
      anos = date.getFullYear() + anos
      date.setYear(anos)
      return date
    },
    DaysBetween: function (initialDate, finalDate) {
      if (!(initialDate instanceof Date)) { initialDate = ui.Parse.Date(initialDate) }
      if (!(finalDate instanceof Date)) { finalDate = ui.Parse.Date(finalDate) }
      return differenceInCalendarDays(finalDate, initialDate)
    },
    IsValid: function (value, dateFormat) {
      const valid = isValid(ui.Parse.Date(value, dateFormat))
      return valid
    }
  },
  Guid: {
    New () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; var v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  }
}

export default ui

function notify (app, title, message, type) {
  if (message && message.message) { message = message.message }
  const localApp = new app({})

  localApp.$notify({
    group: 'notifications-bottom-right',
    type: type,
    title: title || 'Erro',
    text: message ? message.replace(/\n/g, '<br/>') : ''
  })
}

// eslint-disable-next-line no-extend-native
String.prototype.regexIndexOf = function (regex, startpos) {
  var indexOf = this.substring(startpos || 0).search(regex);
  return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
}

// eslint-disable-next-line no-extend-native
String.prototype.regexLastIndexOf = function (regex, startpos) {
  regex = (regex.global) ? regex : new RegExp(regex.source, 'g' + (regex.ignoreCase ? 'i' : '') + (regex.multiLine ? 'm' : ''));
  if (typeof (startpos) === 'undefined') {
    startpos = this.length;
  } else if (startpos < 0) {
    startpos = 0;
  }
  var stringToWorkWith = this.substring(0, startpos + 1);
  var lastIndexOf = -1;
  var nextStop = 0;
  var result
  while ((result = regex.exec(stringToWorkWith)) != null) {
    lastIndexOf = result.index;
    regex.lastIndex = ++nextStop;
  }
  return lastIndexOf;
}
